import { SettingSchema } from 'api/src/core/schemas/SettingSchema';
import makeAutoObservable from 'mobx-store-inheritance';
import { ItemWithLabel } from '../../../components';
import extractValue, { EventOrValue } from '../../../store/utils/extractValue';
import { ZodModel } from '../../../store/ZodModel';

export default class Setting extends ZodModel(SettingSchema) {
  isEditing = false;
  previousValue: string;

  constructor(dto: Setting['__createType']) {
    super(dto);
    makeAutoObservable(this);
    this.previousValue = this.value;
  }

  get title() {
    return settingConfigurations[this.id].title || '';
  }

  get options(): ItemWithLabel[] {
    return settingConfigurations[this.id].options || [];
  }

  get type() {
    return settingConfigurations[this.id].type || 'text';
  }

  handleChange(event: EventOrValue<keyof Setting>) {
    const { name, value } = extractValue<keyof Setting>(event);
    Object.assign(this, { [name]: value });
  }

  toApiUpdateDto(): any {
    return this.value;
  }

  setIsEditing(value: boolean) {
    this.isEditing = value;
  }

  startEdit() {
    this.setIsEditing(true);
  }

  commitEdit() {
    this.setIsEditing(false);
    this.previousValue = this.value;
  }

  rejectEdit() {
    this.setIsEditing(false);
    this.value = this.previousValue;
  }
}

const settingConfigurations = {
  emailerService: {
    title: 'Email service provider',
    type: 'select',
    options: [
      { value: 'aws', label: 'Amazon SES' },
      { value: 'sendgrid', label: 'SendGrid' },
    ],
  },
} as const satisfies Record<string, SettingConfiguration>;

type SettingConfiguration = SelectType;

interface SelectType extends BaseType {
  options: ItemWithLabel[];
  type: 'select';
}

interface BaseType {
  title: string;
}
